import script from "./AddNewOneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewOneDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNewOneDialog.vue?vue&type=style&index=0&id=584c0294&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584c0294"]])

export default __exports__